import { API_CONFIG } from '@/config/api';
import { logger } from '@equip/utils/logger';

const JIT_TIMEOUT_MS = 10_000;

/**
 * Fire-and-forget POST to /api/v1/users/me so the DB record reflects
 * any profile or role changes that arrived with the refreshed token.
 *
 * Uses fetch directly to avoid a circular import with httpClient.
 */
export const triggerJitProvisioning = (accessToken: string): void => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), JIT_TIMEOUT_MS);

  fetch(`${API_CONFIG.BASE_URL}/api/v1/users/me`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: '{}',
    signal: controller.signal,
  })
    .then((res) => {
      if (!res.ok) {
        logger.warn('JIT provisioning returned non-OK status', {
          component: 'jitProvision',
          status: res.status,
        });
      }
    })
    .catch((err: unknown) => {
      logger.warn('JIT provisioning call failed — role changes may not persist until next refresh', {
        component: 'jitProvision',
        error: String(err),
      });
    })
    .finally(() => clearTimeout(timeoutId));
};
